interface HeroProps {
  onQuoteClick: () => void;
}

export default function Hero({ onQuoteClick }: HeroProps) {
  return (
    <section id="hero" className="relative w-full min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/b4dba2124ca849fb4bae62b58df88d15.jpg"
          alt="Post-construction cleaning in Las Vegas - Quiroz Construction Cleaning"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/60 to-black/30"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-black/20"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-6 md:px-16 lg:px-24 pt-24 pb-16">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-[#C9A84C]/20 border border-[#C9A84C]/40 px-4 py-1.5 rounded-sm mb-6">
            <div className="w-1.5 h-1.5 bg-[#C9A84C] rounded-full"></div>
            <span className="font-inter text-[#C9A84C] text-xs tracking-widest uppercase">Las Vegas, Nevada</span>
          </div>

          {/* H1 */}
          <h1 className="font-barlow-condensed font-900 text-white leading-none mb-6">
            <span className="block text-5xl md:text-7xl lg:text-8xl">POST-CONSTRUCTION</span>
            <span className="block text-5xl md:text-7xl lg:text-8xl">CLEANING DONE</span>
            <span className="block text-5xl md:text-7xl lg:text-8xl text-[#C9A84C]">RIGHT THE FIRST TIME.</span>
          </h1>

          {/* Subheadline */}
          <p className="font-inter text-white/75 text-base md:text-lg leading-relaxed max-w-xl mb-10">
            Professional construction cleaning services in Las Vegas delivering spotless, move-in-ready results for contractors, builders, and property owners.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={onQuoteClick}
              className="bg-[#C9A84C] hover:bg-[#E8C96A] text-[#1a1a1a] font-barlow font-800 text-sm px-8 py-4 rounded-sm transition-all duration-200 cursor-pointer whitespace-nowrap tracking-widest uppercase"
            >
              Get a Quote
            </button>
            <a
              href="tel:+17022494799"
              className="flex items-center justify-center gap-2 border border-white/40 hover:border-white text-white font-barlow font-600 text-sm px-8 py-4 rounded-sm transition-all duration-200 cursor-pointer whitespace-nowrap tracking-widest uppercase"
            >
              <i className="ri-phone-line text-[#C9A84C]"></i>
              Call Now
            </a>
          </div>

          {/* Stats row */}
          <div className="flex flex-wrap gap-8 mt-14 pt-10 border-t border-white/15">
            {[
              { value: '500+', label: 'Projects Completed' },
              { value: '100%', label: 'Satisfaction Focus' },
              { value: '10+', label: 'Years Experience' },
            ].map((stat) => (
              <div key={stat.label}>
                <div className="font-barlow-condensed font-900 text-white text-3xl md:text-4xl leading-none">{stat.value}</div>
                <div className="font-inter text-white/50 text-xs tracking-wide mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <div className="w-px h-10 bg-gradient-to-b from-transparent to-white/40"></div>
        <i className="ri-arrow-down-line text-white/40 text-sm"></i>
      </div>
    </section>
  );
}
